import { Review } from '@filmweb/sanity-types';
import DiceRatings from 'src/components/diceratings/DiceRatings';
import UserRatings from "src/components/film/filmwebid/UserRatings";
import styles from './Ratings.module.css';

//#region [Props]
type RatingsProps = {
	reviews?: Review[];
	className?: string;
	edi?: string;
	streamingId?: number;
	hideUserRatings?: boolean;

};
//#endregion

//#region [Component]
export default function Ratings({ reviews, className, edi, streamingId, hideUserRatings = false }: RatingsProps) {
	return <div className={`${styles.ratingsContainer} ${className ?? ''}`.trim()}>
		{!hideUserRatings && <UserRatings edi={edi} streamingId={streamingId} />}
		<DiceRatings className={styles.diceRatings} reviews={reviews} />
	</div>;
}
//#endregion

//#region [Styles]
//#endregion
